export const types = {
  GETTING_CAR_BRANDS_MODELS_TASCO: 'GETTING_CAR_BRANDS_MODELS_TASCO',
  GETTING_CAR_MIC_BRANDS: 'GETTING_CAR_MIC_BRANDS',
  GETTING_CAR_MIC_MODELS: 'GETTING_CAR_MIC_MODELS',
  GET_CAR_BRANDS_SUCCESS: 'GET_CAR_BRANDS_SUCCESS',
  GET_CAR_MODELS_SUCCESS: 'GET_CAR_MODELS_SUCCESS',
  GET_CAR_BRANDS_FAIL: 'GET_CAR_BRANDS_FAIL',
  GET_CAR_MODELS_FAIL: 'GET_CAR_MODELS_FAIL',
  CLEAR_CAR_BRANDS: 'CLEAR_CAR_BRANDS',
  GETTING_BRAND_MODEL_BY_COMPANY: 'GETTING_BRAND_MODEL_BY_COMPANY',
  GET_BRAND_MODEL_BY_COMPANY_SUCCESS: 'GET_BRAND_MODEL_BY_COMPANY_SUCCESS',
  GET_BRAND_MODEL_BY_COMPANY_FAIL: 'GET_BRAND_MODEL_BY_COMPANY_FAIL',
}
